"use client";

import { Button } from "@/components/ui/button";
import { useEffect } from "react";

interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="flex h-screen flex-col items-center justify-center bg-background p-4 text-center">
      <h1 className="text-3xl font-bold mb-4">Error</h1>
      <p className="text-muted-foreground mb-4">
        {error.message || "Something went wrong."}
      </p>
      <Button onClick={reset}>Try Again</Button>
    </main>
  );
}
